<template>
  <div class="purchaseSaleList hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item
          label="查询日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" :loading="loading" />
    <!-- 表格 -->
    <!-- 购销计划一览表 -->
    <purchaseSaleList
      ref="purchaseSaleList"
      :table-data="tableData"
    />
    <br><br>
    <!--当日行情表 -->
    <dailyQuotationSheet
      ref="dailyQuotationSheet"
      :query="query"
    />
    <br><br>
    <!--基本担保履约资金帐户日报表 -->
    <dailyStatementOfCapitalAccount
      ref="dailyStatementOfCapitalAccount"
      :query="query"
    />
    <br><br>
    <!--成交汇总 -->
    <transactionSummary
      ref="transactionSummary"
      :query="query"
    />
    <br><br>
    <!--成交明细 -->
    <transactionDetails
      ref="transactionDetails"
      :query="query"
    />
    <br><br>
    <!--套利成交明细 -->
    <arbitrageTransactionDetails
      ref="arbitrageTransactionDetails"
      :query="query"
    />
    <!--订货汇总 -->
    <orderSummary
      ref="orderSummary"
      :query="query"
    />
    <br><br>
    <!--订货明细 -->
    <orderDetail
      ref="orderDetail"
      :query="query"
    />
    <br><br>
    <!--套利订货明细 -->
    <arbitrageOrderDetail
      ref="arbitrageOrderDetail"
      :query="query"
    />
    <!--当日按购销计划查订货 屏蔽 -->
    <!-- <queryGoodsCodeCurrentPositions
      ref="queryGoodsCodeCurrentPositions"
      :query="query"
    />
    <br><br> -->
    <!--历史按购销计划查订货 -->
    <queryGoodsCodeHisPositions
      ref="queryGoodsCodeHisPositions"
      :query="query"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'
import purchaseSaleList from './components/purchase-sale-list'
import dailyQuotationSheet from './components/daily-quotation-sheet'
import dailyStatementOfCapitalAccount from './components/daily-statement-of-capital-account'
import transactionSummary from './components/transaction-summary'
import transactionDetails from './components/transaction-details'
import arbitrageTransactionDetails from './components/arbitrage-transaction-details'
import orderSummary from './components/order-summary'
import orderDetail from './components/order-detail'
import arbitrageOrderDetail from './components/arbitrage-order-detail'
// import queryGoodsCodeCurrentPositions from './components/queryGoodsCodeCurrentPositions'
import queryGoodsCodeHisPositions from './components/queryGoodsCodeHisPositions'

function Query () {
  this.marketId = '000' // 组织
  this.date = new Date() // 日期
}
export default {
  name: 'MonthlyReport',
  components: {
    purchaseSaleList,
    dailyQuotationSheet,
    dailyStatementOfCapitalAccount,
    transactionSummary,
    transactionDetails,
    arbitrageTransactionDetails,
    orderSummary,
    orderDetail,
    arbitrageOrderDetail,
    // queryGoodsCodeCurrentPositions,
    queryGoodsCodeHisPositions
  },
  data () {
    return {
      query: new Query(),
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tableData: {}, // 表格数据
      marketId: '',
      tradingDate: '',
      loading: false, // 下载loading
    }
  },
  mounted () {
    this.fetchList()
    this.getUserInfo() // 获取用户信息
  },
  methods: {
    // 分页查询
    fetchList (currentPage, pageSize) {
      if (!this.query.date) {
        this.$message.error('日期必选')
        return
      }
      this.marketId = this.query.marketId
      this.tradingDate = dayJs(this.query.date).format('YYYYMMDD')
      this.$refs.dailyQuotationSheet.fetchList(currentPage, pageSize)
      this.$refs.dailyStatementOfCapitalAccount.fetchList(currentPage, pageSize)
      this.$refs.transactionSummary.fetchList(currentPage, pageSize)
      this.$refs.transactionDetails.fetchList(currentPage, pageSize)
      this.$refs.arbitrageTransactionDetails.fetchList(currentPage, pageSize)
      this.$refs.orderSummary.fetchList(currentPage, pageSize)
      this.$refs.orderDetail.fetchList(currentPage, pageSize)
      this.$refs.arbitrageOrderDetail.fetchList(currentPage, pageSize)
      // this.$refs.queryGoodsCodeCurrentPositions.fetchList(currentPage, pageSize)
      this.$refs.queryGoodsCodeHisPositions.fetchList(currentPage, pageSize)
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.$nextTick(
        this.fetchList(1)
      )
    },
    // 导出
    toDownload () {
      if (!this.query.date) {
        this.$message.error('日期必选')
        return
      }
      this.$store.commit('setHeaderToLS')
      let param = {
        marketId: this.marketId,
        tradingDate: this.tradingDate,
        queryType: '2',
        excelHeadList: [
          {
            execlType: '01',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_当日行情表']
          },
          {
            execlType: '02',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_基本担保履约资金帐户日报表']
          },
          {
            execlType: '03',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_成交汇总']
          },
          {
            execlType: '04',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_成交明细']
          },
          {
            execlType: '05',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_套利成交明细']
          },
          {
            execlType: '06',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_订货汇总']
          },
          {
            execlType: '07',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_订货明细']
          },
          {
            execlType: '08',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_套利订货明细']
          },
          {
            execlType: '09',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_当日按购销计划查订货']
          },
          {
            execlType: '10',
            excelHead: this.$store.state.exportConfig.hisHeader['购销计划一览表_历史按购销计划查订货']
          }
        ]
      }
      this.loading = true
      this.$utils.getExcelFile(this, api.purchaseSaleListExport, param, () => {
        this.loading = false
      })
    },
    async getUserInfo () {
      let marketCodes = this.$store.state.user.info.marketCodes
      if (!marketCodes || marketCodes.length < 0) return // 不存在市场
      let marketIds = marketCodes[0]
      for (let i = 1; i < marketCodes.length; i++) {
        marketIds = marketIds + ',' + marketCodes[i]
      }
      let param = {
        marketIds
      }
      await api.spotPurchaseSaleInquiry.MarketInfo(param).then((res) => {
        this.tableData = res // 获取市场名称
        this.tableData.marketName = res.data ? res.data[0].marketName : ''
        this.tableData.userName = this.$store.state.user.info.userName // 获取客户名称
        this.tableData.userAccount = this.$store.state.user.info.userAccount
      })
    }
  }
}

</script>
<style lang="scss" scoped>
  .purchaseSaleList ::v-deep .report_title {
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;

    .report-line {
      margin-left: 10px;
    }
  }

  .purchaseSaleList ::v-deep .z-table__content {
    min-height: inherit !important
  }

  .purchaseSaleList ::v-deep .el-table thead.is-group th {
    background: none;
    border-right: none;
  }

  ::v-deep .report-line {
    width: 4px;
    height: 14px;
    background-color: #f8bd47;
    display: inline-block;
    vertical-align: middle;
  }

  ::v-deep .report-title {
    color: #333333;
    height: 40px;
    font-weight: bold;
    font-size: 14px;
    margin-left: 10px;
    vertical-align: middle
  }

  ::v-deep .el-table {
    border: none;
  }

// 导出配置组件样式
::v-deep .export_config {
  float: right;
  margin-top: 3px;
}

  .purchaseSaleList ::v-deep .el-table__row td {
    border-right: none
  }

  ::v-deep .report-title+span {
    float: right;

    button {
      height: 34px;
      padding: 0 20px;
    }
  }

</style>
